<template>
  <q-page class="q-px-md">
    <h1 class="text-h5">Users</h1>
    <invite-user-btn
      :account-id="accountId"
      color="primary"
      rounded
      @invited="prepend"
    />
    <users-table :account-id="accountId" class="q-my-md" ref="users" />
  </q-page>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { DetailedUser, List } from '@/type';
import { AccountContextMixin } from '@/mixins';
import InviteUserBtn from '../user/InviteUserBtn.vue';
import UsersTable from '../user/UsersTable.vue';

export default defineComponent({
  meta: {
    title: 'Users',
  },
  mixins: [AccountContextMixin],
  components: {
    InviteUserBtn,
    UsersTable,
  },
  methods: {
    prepend(user: DetailedUser) {
      (this.$refs.users as List).prepend(user);
    },
  },
});
</script>
